export const tagsPt = [
  //
  // 🌱 EMOTIONAL WELL-BEING
  //
  {
    key: "self_compassion",
    label: "Autocompaixão",
    meta: "Bem-estar emocional",
  },
  { key: "self_care", label: "Autocuidado", meta: "Bem-estar emocional" },
  {
    key: "emotion_regulation",
    label: "Regulação emocional",
    meta: "Bem-estar emocional",
  },
  { key: "acceptance", label: "Aceitação", meta: "ACT" },
  { key: "mindfulness", label: "Mindfulness", meta: "Atenção plena" },
  { key: "compassion", label: "Compaixão", meta: "Bem-estar emocional" },
  {
    key: "reduce_self_criticism",
    label: "Reduzir autocobrança",
    meta: "Bem-estar emocional",
  },

  //
  // 😌 ANXIETY & STRESS
  //
  { key: "anxiety", label: "Ansiedade", meta: "Saúde mental" },
  { key: "social_anxiety", label: "Ansiedade social", meta: "Saúde mental" },
  { key: "stress", label: "Estresse", meta: "Saúde mental" },
  { key: "worry", label: "Preocupação excessiva", meta: "Saúde mental" },
  { key: "body_tension", label: "Tensão corporal", meta: "Saúde mental" },

  //
  // 🌙 SLEEP & REST
  //
  { key: "sleep", label: "Sono", meta: "Bem-estar físico" },
  { key: "insomnia", label: "Insônia", meta: "Bem-estar físico" },
  {
    key: "circadian_rhythm",
    label: "Ritmo circadiano",
    meta: "Bem-estar físico",
  },

  //
  // 🧠 FOCUS & PRODUCTIVITY
  //
  { key: "focus", label: "Foco", meta: "Produtividade" },
  { key: "concentration", label: "Concentração", meta: "Produtividade" },
  { key: "organization", label: "Organização", meta: "Produtividade" },
  { key: "consistency", label: "Consistência", meta: "Produtividade" },
  { key: "procrastination", label: "Procrastinação", meta: "Produtividade" },
  { key: "routine", label: "Rotina", meta: "Produtividade" },

  //
  // 🏃 MOVEMENT & HABITS
  //
  { key: "exercise", label: "Exercício físico", meta: "Hábitos" },
  { key: "stretching", label: "Alongamento", meta: "Hábitos" },
  { key: "breathing", label: "Exercícios de respiração", meta: "Mindfulness" },
  { key: "nutrition", label: "Alimentação equilibrada", meta: "Hábitos" },
  { key: "metabolism", label: "Metabolismo", meta: "Nutrição" },

  //
  // 🤝 RELATIONSHIPS
  //
  { key: "relationships", label: "Relacionamentos", meta: "Vida pessoal" },
  { key: "communication", label: "Comunicação", meta: "Vida pessoal" },
  { key: "boundaries", label: "Limites", meta: "Vida pessoal" },
  { key: "connection", label: "Conexão com outros", meta: "Vida pessoal" },
  { key: "assertiveness", label: "Assertividade", meta: "Comunicação" },

  //
  // 🎯 VALUES & PURPOSE (ACT)
  //
  { key: "values", label: "Clareza de valores", meta: "ACT" },
  { key: "committed_action", label: "Ação comprometida", meta: "ACT" },
  { key: "purpose", label: "Propósito", meta: "ACT" },
  { key: "authenticity", label: "Autenticidade", meta: "Valores" },

  //
  // 🧩 COGNITION & MENTAL HABITS
  //
  {
    key: "psychological_flexibility",
    label: "Flexibilidade psicológica",
    meta: "ACT",
  },
  { key: "cognitive_defusion", label: "Desfusão cognitiva", meta: "ACT" },
  { key: "rumination", label: "Reduzir ruminação", meta: "Saúde mental" },
  { key: "memory", label: "Memória", meta: "Cognição" },

  //
  // 🌿 LIFESTYLE
  //
  { key: "minimalism", label: "Minimalismo", meta: "Estilo de vida" },
  { key: "nature", label: "Contato com a natureza", meta: "Bem-estar" },
  { key: "creativity", label: "Criatividade", meta: "Estilo de vida" },

  //
  // 💼 PROFESSIONAL LIFE
  //
  { key: "career", label: "Carreira", meta: "Profissional" },
  { key: "leadership", label: "Liderança", meta: "Profissional" },
  {
    key: "work_life_balance",
    label: "Equilíbrio trabalho-vida",
    meta: "Profissional",
  },
];

export const tagsEn = [
  //
  // 🌱 EMOTIONAL WELL-BEING
  //
  {
    key: "self_compassion",
    label: "Self-compassion",
    meta: "Emotional well-being",
  },
  { key: "self_care", label: "Self-care", meta: "Emotional well-being" },
  {
    key: "emotion_regulation",
    label: "Emotion regulation",
    meta: "Emotional well-being",
  },
  { key: "acceptance", label: "Acceptance", meta: "ACT" },
  { key: "mindfulness", label: "Mindfulness", meta: "Mindfulness" },
  { key: "compassion", label: "Compassion", meta: "Emotional well-being" },
  {
    key: "reduce_self_criticism",
    label: "Reduce self-criticism",
    meta: "Emotional well-being",
  },

  //
  // 😌 ANXIETY & STRESS
  //
  { key: "anxiety", label: "Anxiety", meta: "Mental health" },
  { key: "social_anxiety", label: "Social anxiety", meta: "Mental health" },
  { key: "stress", label: "Stress", meta: "Mental health" },
  { key: "worry", label: "Excessive worry", meta: "Mental health" },
  { key: "body_tension", label: "Body tension", meta: "Mental health" },

  //
  // 🌙 SLEEP & REST
  //
  { key: "sleep", label: "Sleep", meta: "Physical well-being" },
  { key: "insomnia", label: "Insomnia", meta: "Physical well-being" },
  {
    key: "circadian_rhythm",
    label: "Circadian rhythm",
    meta: "Physical well-being",
  },

  //
  // 🧠 FOCUS & PRODUCTIVITY
  //
  { key: "focus", label: "Focus", meta: "Productivity" },
  { key: "concentration", label: "Concentration", meta: "Productivity" },
  { key: "organization", label: "Organization", meta: "Productivity" },
  { key: "consistency", label: "Consistency", meta: "Productivity" },
  { key: "procrastination", label: "Procrastination", meta: "Productivity" },
  { key: "routine", label: "Routine", meta: "Productivity" },

  //
  // 🏃 MOVEMENT & HABITS
  //
  { key: "exercise", label: "Physical exercise", meta: "Habits" },
  { key: "stretching", label: "Stretching", meta: "Habits" },
  { key: "breathing", label: "Breathing exercises", meta: "Mindfulness" },
  { key: "nutrition", label: "Balanced nutrition", meta: "Habits" },
  { key: "metabolism", label: "Metabolism", meta: "Nutrition" },

  //
  // 🤝 RELATIONSHIPS
  //
  { key: "relationships", label: "Relationships", meta: "Personal life" },
  { key: "communication", label: "Communication", meta: "Personal life" },
  { key: "boundaries", label: "Boundaries", meta: "Personal life" },
  { key: "connection", label: "Connection with others", meta: "Personal life" },
  { key: "assertiveness", label: "Assertiveness", meta: "Communication" },

  //
  // 🎯 VALUES & PURPOSE (ACT)
  //
  { key: "values", label: "Values clarity", meta: "ACT" },
  { key: "committed_action", label: "Committed action", meta: "ACT" },
  { key: "purpose", label: "Purpose", meta: "ACT" },
  { key: "authenticity", label: "Authenticity", meta: "Values" },

  //
  // 🧩 COGNITION & MENTAL HABITS
  //
  {
    key: "psychological_flexibility",
    label: "Psychological flexibility",
    meta: "ACT",
  },
  { key: "cognitive_defusion", label: "Cognitive defusion", meta: "ACT" },
  { key: "rumination", label: "Reduce rumination", meta: "Mental health" },
  { key: "memory", label: "Memory", meta: "Cognition" },

  //
  // 🌿 LIFESTYLE
  //
  { key: "minimalism", label: "Minimalism", meta: "Lifestyle" },
  { key: "nature", label: "Connection with nature", meta: "Well-being" },
  { key: "creativity", label: "Creativity", meta: "Lifestyle" },

  //
  // 💼 PROFESSIONAL LIFE
  //
  { key: "career", label: "Career", meta: "Professional" },
  { key: "leadership", label: "Leadership", meta: "Professional" },
  {
    key: "work_life_balance",
    label: "Work–life balance",
    meta: "Professional",
  },
];
